import React from "react";

function TableActionIcon({
    src,
    alt = "",
    title,
    disabled = false,
    onClick,
    imageClassName = "editImage",
    size = 30,
}) {
    return (
        <button
            type="button"
            className="btn btn-link p-0 border-0 table-action-btn"
            title={title}
            disabled={disabled}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (!disabled && onClick) {
                    onClick(event);
                }
            }}
        >
            <img
                src={src}
                alt={alt}
                className={imageClassName}
                draggable={false}
                style={{width: size, pointerEvents: "none"}}
            />
        </button>
    );
}

export default TableActionIcon;
